import CategoryBox from 'components/CategoryBox';
import {
  disableTypeAdsImage,
  enableTypeAdsImage,
} from 'utilities/helper/typeAdsImageSwitcher/farmTypesImageSwitcher';

const CategoryList = ({list, appType}: IGetCategoryTypeSaleList) => {
  return (
    <>
      <div className="mx-3">
        <p className="my-6">نوع فروش را انتخاب کنید</p>
        <div className="grid gap-4 grid-cols-2">
          {list?.map((item, index) => (
            <CategoryBox
              appType={appType}
              type={item.type}
              disabled={true}
              key={index}
              title={item.title}
              icon={
                item.is_enable
                  ? enableTypeAdsImage[item.type]
                  : disableTypeAdsImage[item.type]
              }
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default CategoryList;
